export default __webpack_public_path__ + "static/media/info-kredit.2b4d7b4c.png";